export type Person = {
    id: string;
    guid: string;
} & Name;

export type Name = {
    firstName: string;
    lastName: string;
}

export const fullName = ({
                             firstName,
                             lastName
                         }: Name): string => [firstName, lastName].filter(value => !!value).join(" ").trim();

